{
    "NAME": "CallRecIntegration",
    "AddCallRecIntegrationTitle": "Aggiungere l'integrazione della registrazione delle chiamate",
    "ModifyCallRecIntegrationTitle": "Modificare l'integrazione della registrazione delle chiamate",
    "TabGeneralTitle": "Generale",
    "TabScopeAssignmentsTitle": "Assegnazioni di ambito",
    "TabApiCommunicationsTitle": "Comunicazioni Api",
    "TabDubberCommunicationsTitle": "Comunicazioni Dubber",
    "IdentifierGUID": "Identificatore (GUID):",
    "IdentifierGUIDPlaceholder": "[Assegnato automaticamente]",
    "IntegrationType": "Tipo di integrazione:",
    "IntegrationType_1": "[Tipo sconosciuto o non specificato].",
    "IntegrationType_2": "Dubber Corporation Limited",
    "ModifyCallRecIntegrationDescriptionFormLabel": "Descrizione:",
    "DubberApiComSettingsLocationUrls": "URL di localizzazione Dubber:",
    "ApiComSettingsIPAddrOne": "Indirizzo IP 1 (MAIN):",
    "ApiComSettingsIPAddrTwo": "Indirizzo IP 2 (SECONDARIO):",
    "ApiComSettingsAuthDetailsMainTitle": "Dettagli di autenticazione (MAIN)",
    "ApiComSettingsAuthDetailsMainUserName": "Nome utente (MAIN):",
    "ApiComSettingsAuthDetailsMainUserPassword": "Password (MAIN):",
    "ApiComSettingsAuthDetailsSecondaryTitle": "Dettagli di autenticazione (SECONDARIA):",
    "ApiComSettingsAuthDetailsSecondaryUserName": "Nome utente (secondario):",
    "ApiComSettingsAuthDetailsSecondaryUserPassword": "Password (secondaria):",
    "ApiComSettingsApiParamOne": "Parametro API 1:",
    "ApiComSettingsApiParamTwo": "Parametro API 2:",
    "DubberComSettingsApiParamOne": "Nome del conto (PARTE TRAILING):",
    "DubberComSettingsApiParamTWO": "Account Utente \/ E-MAIL (OPZIONALE):",
    "DubberComSettingsTitle": "Impostazioni di comunicazione di Dubber",
    "DubberComSettingsLocationURL": "URL di localizzazione Dubber:",
    "DubberComSettingsDevAuthTitle": "Autenticazione degli sviluppatori",
    "DubberComSettingsDevAuthUserName": "Nome utente (CHIAVE MASHERYID):",
    "DubberComSettingsDevAuthUserPassword": "Password (MASHERYID SECRET):",
    "DubberComSettingsAccountApiAuthTitle": "Autenticazione API dell'account",
    "DubberComSettingsAccountApiAuthUserName": "Nome utente (API AUTH ID):",
    "DubberComSettingsAccountApiAuthUserPassword": "Password (API AUTH TOKEN):",
    "DubberComSettingAccountName": "Nome del conto (parte finale)",
    "DubberComSettingsAccountUserEmail": "Utente dell'account \/ Email (FACOLTATIVO)",
    "CallRecIntegrationAddModify_UnknownOrDeleted": "[Sconosciuto o cancellato]",
    "CallRecIntegrationAddModify_ServerErrorTitle": "Errori di convalida",
    "CallRecIntegrationAddModify_ValidationWarning": "Assicurarsi che tutti i campi siano compilati correttamente",
    "CallRecIntegrationAddModify_ButtonHelpLabel": "Aiuto?",
    "CallRecIntegrationAddModify_ButtonSubmitLabel": "Risparmiare",
    "CallRecIntegrationAddModify_ButtonCancelLabel": "Annullamento",
    "CallRecIntegrationAddModify_PromptMessage": "Siete sicuri di voler chiudere questa finestra? Tutte le configurazioni modificate andranno perse una volta chiuse.",
    "CallRecIntegrationAddModify_PromptConfirm": "Sì",
    "CallRecIntegrationAddModify_PromptCancel": "Annullamento",
    "Error_TestIntegration_Timeout": "L'accesso al test di integrazione è scaduto",
    "InputField_Change_Username": "[Cambia nome utente]",
    "InputField_Change_Password": "[Cambia password]",
    "DubberComSettings_Parameters": "Parametri",
    "DubberComSettings_TestIntegrationAuth": "Autenticazione di integrazione del test",
    "DubberSuccessfullIntegration": "Le impostazioni di comunicazione dell'integrazione della registrazione delle chiamate funzionano correttamente"
}